// extracted by mini-css-extract-plugin
export var container = "_vb-0";
export var table = "_vb-2";
export var tableWrapper = "_vb-1";